function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import VerticalTabs from "segments/desktop/core-components/vertical-tabs/vertical-tabs";
import { StyledVerticalTabsComponent } from "./vertical-tabs-component.scss";
import DefaultProps from "./default-props";
const VerticalTabsComponent = (props)=>{
    return /*#__PURE__*/ _jsx(StyledVerticalTabsComponent, {
        className: "vertical-tabs-component",
        children: /*#__PURE__*/ _jsx(VerticalTabs, _object_spread({}, props))
    });
};
VerticalTabsComponent.defaultProps = DefaultProps;
export default VerticalTabsComponent;
